import styled, { keyframes } from 'styled-components'

const flowRightToLeft = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`

const ReviewsWrapper = styled.div`
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  margin-top: 64px;
`

const ReviewsTrack = styled.div`
  display: flex;
  gap: 20px;
  animation: ${flowRightToLeft} 40s linear infinite;
  will-change: transform;
`

const ReviewCardLoop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 320px;
  height: auto;
  padding: 24px;
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 20px;
  word-wrap: break-word;
  white-space: normal;
`

export { ReviewsWrapper, ReviewsTrack, ReviewCardLoop }
